import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { CountBubble } from '@/components/ui';
import { NAV_ITEMS, NAV_ALIASES } from './navItems';
import { useNavBadges } from './useNavBadges';

/** Landscape side rail (96px). Active = accent-soft pill. */
export const Rail: React.FC = () => {
    const { t } = useTranslation();
    const badges = useNavBadges();
    const { pathname } = useLocation();
    const current = NAV_ALIASES[pathname] ?? pathname;
    // 06–09 (checkout → QRIS → sale complete) are full-bleed in the design: no rail
    if (pathname === '/checkout') return null;

    return (
        <aside className="hidden lg:flex w-24 shrink-0 flex-col items-center gap-2 border-r border-line-subtle bg-surface-card py-3.5">
            <img src="/logo.svg" alt="runut POS" draggable={false} className="mb-1.5 h-10 w-10 rounded-[24%]" />
            {NAV_ITEMS.map((item) => {
                const active = current.startsWith(item.to);
                const count = item.badge ? badges[item.badge] : 0;
                return (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        aria-current={active ? 'page' : undefined}
                        className={clsx(
                            'flex w-[72px] flex-col items-center gap-1 rounded-md py-2 text-[11px] transition-colors',
                            active ? 'bg-accentsoft text-accent-700 font-black' : 'text-ink-muted font-bold hover:bg-surface-sunken hover:text-ink-primary',
                        )}
                    >
                        <span className="relative">
                            <item.icon className="h-5 w-5" />
                            <CountBubble count={count} tone={item.badge === 'held' ? 'accent' : 'danger'} className="absolute -top-2 -right-3" />
                        </span>
                        {t(item.labelKey)}
                    </NavLink>
                );
            })}
        </aside>
    );
};
export default Rail;
